import { cookie } from "./cookie"
import {
  setCookieDropdownValue,
  setCookieCombinedButtonValue,
} from "../helpers/util"
import { CookieType } from "../helpers/enums"

/* Check for and set language cookie */
export const languageCookie = () => {
  cookie(CookieType.LANGUAGE)
  setCookieDropdownValue(CookieType.LANGUAGE)
  setCookieCombinedButtonValue(CookieType.LANGUAGE)

  window.addEventListener("resize", () => {
    setCookieCombinedButtonValue(CookieType.LANGUAGE)
  })

  window.dispatchEvent(new Event("resize"))
}
